import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../loading/loading.component";
import DataTable from "react-data-table-component";
import InputFilter from "../input-filter/input-filter.component";
import Score from "../../@types/score.interface";
import { DesktopWindows } from "@material-ui/icons";

interface IProps {
    scores: Score[] | null;
}

interface data {
    no: number;
    course_name: string;
    score: number;
}

export default function ViewScores({ scores }: IProps) {
    const history = useHistory();
    const [data, setData] = useState<data[]>([]);
    const [isFetching, setIsFetching] = useState<boolean>(true);


    // useEffect(() => {
    //     console.log("ada juga");
    //     setData([]);
    // },[scores]);

    useEffect(() => {
        if (scores !== null) {
            setData([]);
            for (let index = 0; index < scores.length; index++) {
                data.push({
                    no: index + 1,
                    course_name: scores[index].course_name,
                    score: scores[index].score,
                });
            }
            setIsFetching(false);
        }
    }, [scores,history]);


    const columns = [
        {
            name: "No",
            selector: "no",
            sortable: true,
            width: "50px",
        },
        {
            name: "Course",
            selector: "course_name",
            sortable: true,
        },
        {
            name: "Score",
            selector: "score",
            sortable: true,
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: "16px",
            },
        },
        rows: {
            style: {
                fontSize: "16px",
            },
        },
        pagination: {
            style: {
                fontSize: "16px",
                fontWeight: 600,
            },
        },
    };

    const [filterData, setFilterData] = useState<data[]>(data);
    const [val, setVal] = useState<string>("");

    const onHandleChange = (evt: any) => {
        let filterText = evt.target.value;
        if (filterText !== "") {
            setFilterData(
                data.filter(
                    (quiz) =>
                        quiz.course_name &&
                        quiz.course_name
                            .toLowerCase()
                            .includes(filterText.toLowerCase())
                )
            );
        } else setFilterData(data);
        setVal(filterText);
    };

    const onClear = () => {
        setFilterData(data);
        setVal("");
    };

    return (
        <div className="list-quiz">
            <div className="list-quiz__title">
                <h2 className="heading">View Quizzes</h2>
            </div>
            <div className="list-quiz__detail">
                {isFetching ? (
                    <Loading />
                ) : (
                    <div className="list-quiz__detail__table">
                        <InputFilter
                            classNames="list-quiz__detail__table__filter"
                            value={val}
                            onFilter={onHandleChange}
                            onClear={onClear}
                        />

                        <DataTable
                            className="scrollbar"
                            columns={columns}
                            data={filterData}
                            customStyles={customStyles}
                            noHeader
                            responsive
                            pagination
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
